@file:OptIn(InternalResourceApi::class)

package one.devsbox.www.www_portal.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/one.devsbox.www.www_portal.generated.resources/"

@delegate:ResourceContentHash(-1_385_651_888)
internal val Res.string.ui_target_locations: StringResource by lazy {
      StringResource("string:ui_target_locations", "ui_target_locations", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27429, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26149, 39),
      ))
    }

@delegate:ResourceContentHash(1_300_809_559)
internal val Res.string.ui_target_resource: StringResource by lazy {
      StringResource("string:ui_target_resource", "ui_target_resource", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27548, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26268, 38),
      ))
    }

@delegate:ResourceContentHash(1_997_239_247)
internal val Res.string.ui_target_resources: StringResource by lazy {
      StringResource("string:ui_target_resources", "ui_target_resources", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27508, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26228, 39),
      ))
    }

@delegate:ResourceContentHash(-165_470_589)
internal val Res.string.ui_target_user: StringResource by lazy {
      StringResource("string:ui_target_user", "ui_target_user", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27619, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26339, 30),
      ))
    }

@delegate:ResourceContentHash(-165_500_442)
internal val Res.string.ui_target_users: StringResource by lazy {
      StringResource("string:ui_target_users", "ui_target_users", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27583, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26307, 31),
      ))
    }

@delegate:ResourceContentHash(-723_488_708)
internal val Res.string.ui_uploader_btn_image: StringResource by lazy {
      StringResource("string:ui_uploader_btn_image", "ui_uploader_btn_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27654, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26370, 45),
      ))
    }

@delegate:ResourceContentHash(-1_976_841_787)
internal val Res.string.ui_uploader_btn_pdf: StringResource by lazy {
      StringResource("string:ui_uploader_btn_pdf", "ui_uploader_btn_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27704, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26416, 43),
      ))
    }

@delegate:ResourceContentHash(851_642_094)
internal val Res.string.ui_uploader_btn_try_again: StringResource by lazy {
      StringResource("string:ui_uploader_btn_try_again", "ui_uploader_btn_try_again", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27748, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26460, 45),
      ))
    }

@delegate:ResourceContentHash(1_205_336_578)
internal val Res.string.ui_uploader_btn_video: StringResource by lazy {
      StringResource("string:ui_uploader_btn_video", "ui_uploader_btn_video", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27806, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26506, 45),
      ))
    }

@delegate:ResourceContentHash(-136_658_165)
internal val Res.string.ui_uploader_desc_image: StringResource by lazy {
      StringResource("string:ui_uploader_desc_image", "ui_uploader_desc_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27856, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26552, 98),
      ))
    }

@delegate:ResourceContentHash(-2_013_069_012)
internal val Res.string.ui_uploader_desc_pdf: StringResource by lazy {
      StringResource("string:ui_uploader_desc_pdf", "ui_uploader_desc_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27959, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26651, 76),
      ))
    }

@delegate:ResourceContentHash(353_421_141)
internal val Res.string.ui_uploader_desc_video: StringResource by lazy {
      StringResource("string:ui_uploader_desc_video", "ui_uploader_desc_video", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28040, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26728, 94),
      ))
    }

@delegate:ResourceContentHash(-613_029_644)
internal val Res.string.ui_uploader_error_prefix: StringResource by lazy {
      StringResource("string:ui_uploader_error_prefix", "ui_uploader_error_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28139, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26823, 60),
      ))
    }

@delegate:ResourceContentHash(-416_868_614)
internal val Res.string.ui_uploader_fail_title: StringResource by lazy {
      StringResource("string:ui_uploader_fail_title", "ui_uploader_fail_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28212, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26884, 58),
      ))
    }

@delegate:ResourceContentHash(-1_807_433_538)
internal val Res.string.ui_uploader_status_back: StringResource by lazy {
      StringResource("string:ui_uploader_status_back", "ui_uploader_status_back", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28267, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26943, 39),
      ))
    }

@delegate:ResourceContentHash(1_341_409_348)
internal val Res.string.ui_uploader_status_init: StringResource by lazy {
      StringResource("string:ui_uploader_status_init", "ui_uploader_status_init", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28307, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26983, 63),
      ))
    }

@delegate:ResourceContentHash(475_135_225)
internal val Res.string.ui_uploader_status_processing: StringResource by lazy {
      StringResource("string:ui_uploader_status_processing", "ui_uploader_status_processing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28371, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27047, 85),
      ))
    }

@delegate:ResourceContentHash(2_077_531_598)
internal val Res.string.ui_uploader_status_secure_legend: StringResource by lazy {
      StringResource("string:ui_uploader_status_secure_legend", "ui_uploader_status_secure_legend", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28469, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27133, 140),
      ))
    }

@delegate:ResourceContentHash(1_871_400_985)
internal val Res.string.ui_uploader_status_secure_transfer: StringResource by lazy {
      StringResource("string:ui_uploader_status_secure_transfer", "ui_uploader_status_secure_transfer", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28618, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27274, 70),
      ))
    }

@delegate:ResourceContentHash(-588_750_528)
internal val Res.string.ui_uploader_status_uploading: StringResource by lazy {
      StringResource("string:ui_uploader_status_uploading", "ui_uploader_status_uploading", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28697, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27345, 60),
      ))
    }

@delegate:ResourceContentHash(664_920_738)
internal val Res.string.ui_uploader_subtitle: StringResource by lazy {
      StringResource("string:ui_uploader_subtitle", "ui_uploader_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28762, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27406, 76),
      ))
    }

@delegate:ResourceContentHash(-792_987_503)
internal val Res.string.ui_uploader_title: StringResource by lazy {
      StringResource("string:ui_uploader_title", "ui_uploader_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28843, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27483, 45),
      ))
    }

@delegate:ResourceContentHash(890_491_875)
internal val Res.string.ui_users_activity_btn_next: StringResource by lazy {
      StringResource("string:ui_users_activity_btn_next", "ui_users_activity_btn_next", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28909, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27529, 42),
      ))
    }

@delegate:ResourceContentHash(651_404_420)
internal val Res.string.ui_users_activity_btn_prev: StringResource by lazy {
      StringResource("string:ui_users_activity_btn_prev", "ui_users_activity_btn_prev", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 28956, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27572, 46),
      ))
    }

@delegate:ResourceContentHash(301_918_664)
internal val Res.string.ui_users_activity_empty: StringResource by lazy {
      StringResource("string:ui_users_activity_empty", "ui_users_activity_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29003, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27619, 67),
      ))
    }

@delegate:ResourceContentHash(-822_165_339)
internal val Res.string.ui_users_activity_filter_action: StringResource by lazy {
      StringResource("string:ui_users_activity_filter_action", "ui_users_activity_filter_action", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29083, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27687, 51),
      ))
    }

@delegate:ResourceContentHash(82_546_257)
internal val Res.string.ui_users_activity_filter_all: StringResource by lazy {
      StringResource("string:ui_users_activity_filter_all", "ui_users_activity_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29135, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27739, 40),
      ))
    }

@delegate:ResourceContentHash(-1_684_057_908)
internal val Res.string.ui_users_activity_filter_target: StringResource by lazy {
      StringResource("string:ui_users_activity_filter_target", "ui_users_activity_filter_target", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29176, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27780, 51),
      ))
    }

@delegate:ResourceContentHash(-1_879_381_979)
internal val Res.string.ui_users_activity_header_action: StringResource by lazy {
      StringResource("string:ui_users_activity_header_action", "ui_users_activity_header_action", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29224, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27832, 47),
      ))
    }

@delegate:ResourceContentHash(1_634_444_242)
internal val Res.string.ui_users_activity_header_details: StringResource by lazy {
      StringResource("string:ui_users_activity_header_details", "ui_users_activity_header_details", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29272, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27880, 52),
      ))
    }

@delegate:ResourceContentHash(699_379_114)
internal val Res.string.ui_users_activity_header_timestamp: StringResource by lazy {
      StringResource("string:ui_users_activity_header_timestamp", "ui_users_activity_header_timestamp", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29325, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27933, 54),
      ))
    }

@delegate:ResourceContentHash(-165_470_589)
internal val Res.string.ui_users_activity_header_user: StringResource by lazy {
      StringResource("string:ui_users_activity_header_user", "ui_users_activity_header_user", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29392, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27988, 45),
      ))
    }

@delegate:ResourceContentHash(2_056_327_806)
internal val Res.string.ui_users_activity_hours_ago: StringResource by lazy {
      StringResource("string:ui_users_activity_hours_ago", "ui_users_activity_hours_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29442, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28034, 55),
      ))
    }

@delegate:ResourceContentHash(-2_112_190_972)
internal val Res.string.ui_users_activity_mins_ago: StringResource by lazy {
      StringResource("string:ui_users_activity_mins_ago", "ui_users_activity_mins_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29498, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28090, 54),
      ))
    }

@delegate:ResourceContentHash(-1_503_210_980)
internal val Res.string.ui_users_activity_now: StringResource by lazy {
      StringResource("string:ui_users_activity_now", "ui_users_activity_now", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29553, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28145, 33),
      ))
    }

@delegate:ResourceContentHash(-1_281_005_611)
internal val Res.string.ui_users_activity_title: StringResource by lazy {
      StringResource("string:ui_users_activity_title", "ui_users_activity_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29591, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28179, 47),
      ))
    }

@delegate:ResourceContentHash(-1_193_551_646)
internal val Res.string.ui_users_detail_btn_audit_trail: StringResource by lazy {
      StringResource("string:ui_users_detail_btn_audit_trail", "ui_users_detail_btn_audit_trail", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29647, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28227, 59),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_users_detail_btn_delete: StringResource by lazy {
      StringResource("string:ui_users_detail_btn_delete", "ui_users_detail_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29719, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28287, 42),
      ))
    }

@delegate:ResourceContentHash(-503_216_827)
internal val Res.string.ui_users_detail_btn_edit: StringResource by lazy {
      StringResource("string:ui_users_detail_btn_edit", "ui_users_detail_btn_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29766, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28330, 40),
      ))
    }

@delegate:ResourceContentHash(-1_588_786_152)
internal val Res.string.ui_users_detail_btn_reset_pass: StringResource by lazy {
      StringResource("string:ui_users_detail_btn_reset_pass", "ui_users_detail_btn_reset_pass", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29807, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28371, 54),
      ))
    }

@delegate:ResourceContentHash(-1_238_925_862)
internal val Res.string.ui_users_detail_cat_campaigns: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_campaigns", "ui_users_detail_cat_campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29878, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28426, 49),
      ))
    }

@delegate:ResourceContentHash(-1_995_450_493)
internal val Res.string.ui_users_detail_cat_company: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_company", "ui_users_detail_cat_company", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29928, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28476, 47),
      ))
    }

@delegate:ResourceContentHash(-2_800_520)
internal val Res.string.ui_users_detail_cat_devices: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_devices", "ui_users_detail_cat_devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 29972, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28524, 47),
      ))
    }

@delegate:ResourceContentHash(-1_385_651_888)
internal val Res.string.ui_users_detail_cat_locations: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_locations", "ui_users_detail_cat_locations", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30020, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28572, 49),
      ))
    }

@delegate:ResourceContentHash(-1_592_717_250)
internal val Res.string.ui_users_detail_cat_media: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_media", "ui_users_detail_cat_media", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30070, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28622, 41),
      ))
    }

@delegate:ResourceContentHash(-165_500_442)
internal val Res.string.ui_users_detail_cat_users: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_users", "ui_users_detail_cat_users", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30112, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28664, 41),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_users_detail_delete_btn_confirm: StringResource by lazy {
      StringResource("string:ui_users_detail_delete_btn_confirm", "ui_users_detail_delete_btn_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30158, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28706, 50),
      ))
    }

@delegate:ResourceContentHash(1_573_769_046)
internal val Res.string.ui_users_detail_delete_btn_dismiss: StringResource by lazy {
      StringResource("string:ui_users_detail_delete_btn_dismiss", "ui_users_detail_delete_btn_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30213, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28757, 54),
      ))
    }

@delegate:ResourceContentHash(900_198_363)
internal val Res.string.ui_users_detail_delete_confirm_message: StringResource by lazy {
      StringResource("string:ui_users_detail_delete_confirm_message", "ui_users_detail_delete_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30268, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28812, 142),
      ))
    }

@delegate:ResourceContentHash(-703_793_327)
internal val Res.string.ui_users_detail_delete_confirm_title: StringResource by lazy {
      StringResource("string:ui_users_detail_delete_confirm_title", "ui_users_detail_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30431, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28955, 60),
      ))
    }

@delegate:ResourceContentHash(-645_535_466)
internal val Res.string.ui_users_detail_header_category: StringResource by lazy {
      StringResource("string:ui_users_detail_header_category", "ui_users_detail_header_category", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30500, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29016, 51),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_users_detail_header_delete: StringResource by lazy {
      StringResource("string:ui_users_detail_header_delete", "ui_users_detail_header_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30556, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29068, 45),
      ))
    }

@delegate:ResourceContentHash(-503_216_827)
internal val Res.string.ui_users_detail_header_edit: StringResource by lazy {
      StringResource("string:ui_users_detail_header_edit", "ui_users_detail_header_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30606, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29114, 43),
      ))
    }

@delegate:ResourceContentHash(546_863_784)
internal val Res.string.ui_users_detail_header_view: StringResource by lazy {
      StringResource("string:ui_users_detail_header_view", "ui_users_detail_header_view", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30650, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29158, 43),
      ))
    }

@delegate:ResourceContentHash(1_046_818_917)
internal val Res.string.ui_users_detail_info_dialog_title: StringResource by lazy {
      StringResource("string:ui_users_detail_info_dialog_title", "ui_users_detail_info_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30698, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29202, 65),
      ))
    }

@delegate:ResourceContentHash(-1_741_625_252)
internal val Res.string.ui_users_detail_log_api_key: StringResource by lazy {
      StringResource("string:ui_users_detail_log_api_key", "ui_users_detail_log_api_key", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30856, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29352, 63),
      ))
    }

@delegate:ResourceContentHash(1_732_838_760)
internal val Res.string.ui_users_detail_log_api_key_sub: StringResource by lazy {
      StringResource("string:ui_users_detail_log_api_key_sub", "ui_users_detail_log_api_key_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30772, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29268, 83),
      ))
    }

@delegate:ResourceContentHash(-1_351_564_566)
internal val Res.string.ui_users_detail_log_media: StringResource by lazy {
      StringResource("string:ui_users_detail_log_media", "ui_users_detail_log_media", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31002, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29490, 73),
      ))
    }

@delegate:ResourceContentHash(1_987_753_433)
internal val Res.string.ui_users_detail_log_media_sub: StringResource by lazy {
      StringResource("string:ui_users_detail_log_media_sub", "ui_users_detail_log_media_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 30924, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29416, 73),
      ))
    }

@delegate:ResourceContentHash(-992_941_020)
internal val Res.string.ui_users_detail_log_sync: StringResource by lazy {
      StringResource("string:ui_users_detail_log_sync", "ui_users_detail_log_sync", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31165, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29637, 56),
      ))
    }

@delegate:ResourceContentHash(-9_072_540)
internal val Res.string.ui_users_detail_log_sync_sub: StringResource by lazy {
      StringResource("string:ui_users_detail_log_sync_sub", "ui_users_detail_log_sync_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31088, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29564, 72),
      ))
    }

@delegate:ResourceContentHash(228_077_907)
internal val Res.string.ui_users_detail_reset_success_msg: StringResource by lazy {
      StringResource("string:ui_users_detail_reset_success_msg", "ui_users_detail_reset_success_msg", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31238, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29694, 97),
      ))
    }

@delegate:ResourceContentHash(-914_010_611)
internal val Res.string.ui_users_detail_title_permissions_matrix: StringResource by lazy {
      StringResource("string:ui_users_detail_title_permissions_matrix", "ui_users_detail_title_permissions_matrix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31360, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29792, 72),
      ))
    }

@delegate:ResourceContentHash(1_665_914_557)
internal val Res.string.ui_users_detail_title_recent_logs: StringResource by lazy {
      StringResource("string:ui_users_detail_title_recent_logs", "ui_users_detail_title_recent_logs", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31429, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29865, 65),
      ))
    }

@delegate:ResourceContentHash(-1_295_076_463)
internal val Res.string.ui_users_edit_btn_ok: StringResource by lazy {
      StringResource("string:ui_users_edit_btn_ok", "ui_users_edit_btn_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31503, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29931, 32),
      ))
    }

@delegate:ResourceContentHash(936_220_866)
internal val Res.string.ui_users_edit_btn_save: StringResource by lazy {
      StringResource("string:ui_users_edit_btn_save", "ui_users_edit_btn_save", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31540, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29964, 38),
      ))
    }

@delegate:ResourceContentHash(-1_428_792_705)
internal val Res.string.ui_users_edit_error_title: StringResource by lazy {
      StringResource("string:ui_users_edit_error_title", "ui_users_edit_error_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31579, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30003, 41),
      ))
    }

@delegate:ResourceContentHash(-305_811_738)
internal val Res.string.ui_users_edit_label_full_name: StringResource by lazy {
      StringResource("string:ui_users_edit_label_full_name", "ui_users_edit_label_full_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31625, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30045, 49),
      ))
    }

@delegate:ResourceContentHash(1_071_582_152)
internal val Res.string.ui_users_edit_label_login_id: StringResource by lazy {
      StringResource("string:ui_users_edit_label_login_id", "ui_users_edit_label_login_id", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31675, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30095, 48),
      ))
    }

@delegate:ResourceContentHash(-1_519_802_064)
internal val Res.string.ui_users_edit_role_admin: StringResource by lazy {
      StringResource("string:ui_users_edit_role_admin", "ui_users_edit_role_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31728, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30144, 40),
      ))
    }

@delegate:ResourceContentHash(1_943_914_095)
internal val Res.string.ui_users_edit_role_campaign_publisher: StringResource by lazy {
      StringResource("string:ui_users_edit_role_campaign_publisher", "ui_users_edit_role_campaign_publisher", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31781, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30185, 69),
      ))
    }

@delegate:ResourceContentHash(-1_973_238_195)
internal val Res.string.ui_users_edit_role_campaign_viewer: StringResource by lazy {
      StringResource("string:ui_users_edit_role_campaign_viewer", "ui_users_edit_role_campaign_viewer", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31851, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30255, 62),
      ))
    }

@delegate:ResourceContentHash(633_395_640)
internal val Res.string.ui_users_edit_role_technic: StringResource by lazy {
      StringResource("string:ui_users_edit_role_technic", "ui_users_edit_role_technic", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31922, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30318, 46),
      ))
    }

@delegate:ResourceContentHash(700_475_742)
internal val Res.string.ui_users_edit_role_warning_message: StringResource by lazy {
      StringResource("string:ui_users_edit_role_warning_message", "ui_users_edit_role_warning_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 31969, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30365, 182),
      ))
    }

@delegate:ResourceContentHash(1_660_541_432)
internal val Res.string.ui_users_edit_role_warning_title: StringResource by lazy {
      StringResource("string:ui_users_edit_role_warning_title", "ui_users_edit_role_warning_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32160, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30548, 72),
      ))
    }

@delegate:ResourceContentHash(-1_887_389_032)
internal val Res.string.ui_users_edit_section_roles: StringResource by lazy {
      StringResource("string:ui_users_edit_section_roles", "ui_users_edit_section_roles", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32225, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30621, 51),
      ))
    }

@delegate:ResourceContentHash(878_832_032)
internal val Res.string.ui_users_edit_title_user_profile: StringResource by lazy {
      StringResource("string:ui_users_edit_title_user_profile", "ui_users_edit_title_user_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32285, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30673, 56),
      ))
    }

@delegate:ResourceContentHash(71_543_332)
internal val Res.string.ui_users_listing_btn_add_user: StringResource by lazy {
      StringResource("string:ui_users_listing_btn_add_user", "ui_users_listing_btn_add_user", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32350, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30730, 49),
      ))
    }

@delegate:ResourceContentHash(959_713_004)
internal val Res.string.ui_users_listing_btn_load_more: StringResource by lazy {
      StringResource("string:ui_users_listing_btn_load_more", "ui_users_listing_btn_load_more", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32408, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30780, 50),
      ))
    }

@delegate:ResourceContentHash(-1_091_319_993)
internal val Res.string.ui_users_listing_header_activity: StringResource by lazy {
      StringResource("string:ui_users_listing_header_activity", "ui_users_listing_header_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32467, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30831, 60),
      ))
    }

@delegate:ResourceContentHash(258_217_201)
internal val Res.string.ui_users_listing_header_identity: StringResource by lazy {
      StringResource("string:ui_users_listing_header_identity", "ui_users_listing_header_identity", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32532, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30892, 60),
      ))
    }

@delegate:ResourceContentHash(1_012_410_401)
internal val Res.string.ui_users_listing_no_users_found: StringResource by lazy {
      StringResource("string:ui_users_listing_no_users_found", "ui_users_listing_no_users_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32601, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30953, 99),
      ))
    }

@delegate:ResourceContentHash(-2_042_298_187)
internal val Res.string.ui_users_listing_search_placeholder: StringResource by lazy {
      StringResource("string:ui_users_listing_search_placeholder", "ui_users_listing_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32729, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31053, 63),
      ))
    }

@delegate:ResourceContentHash(549_677_687)
internal val Res.string.ui_users_listing_showing: StringResource by lazy {
      StringResource("string:ui_users_listing_showing", "ui_users_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32801, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31117, 76),
      ))
    }

@delegate:ResourceContentHash(-1_017_529_524)
internal val Res.string.ui_users_splash_desc: StringResource by lazy {
      StringResource("string:ui_users_splash_desc", "ui_users_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 32890, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31194, 192),
      ))
    }

@delegate:ResourceContentHash(1_199_172_666)
internal val Res.string.ui_users_splash_title: StringResource by lazy {
      StringResource("string:ui_users_splash_title", "ui_users_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 33103, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31387, 53),
      ))
    }

@delegate:ResourceContentHash(-512_368_282)
internal val Res.string.users: StringResource by lazy {
      StringResource("string:users", "users", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 33161, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31441, 21),
      ))
    }

@delegate:ResourceContentHash(80_528_753)
internal val Res.string.yes: StringResource by lazy {
      StringResource("string:yes", "yes", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 33187, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31463, 15),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("ui_target_locations", Res.string.ui_target_locations)
  map.put("ui_target_resource", Res.string.ui_target_resource)
  map.put("ui_target_resources", Res.string.ui_target_resources)
  map.put("ui_target_user", Res.string.ui_target_user)
  map.put("ui_target_users", Res.string.ui_target_users)
  map.put("ui_uploader_btn_image", Res.string.ui_uploader_btn_image)
  map.put("ui_uploader_btn_pdf", Res.string.ui_uploader_btn_pdf)
  map.put("ui_uploader_btn_try_again", Res.string.ui_uploader_btn_try_again)
  map.put("ui_uploader_btn_video", Res.string.ui_uploader_btn_video)
  map.put("ui_uploader_desc_image", Res.string.ui_uploader_desc_image)
  map.put("ui_uploader_desc_pdf", Res.string.ui_uploader_desc_pdf)
  map.put("ui_uploader_desc_video", Res.string.ui_uploader_desc_video)
  map.put("ui_uploader_error_prefix", Res.string.ui_uploader_error_prefix)
  map.put("ui_uploader_fail_title", Res.string.ui_uploader_fail_title)
  map.put("ui_uploader_status_back", Res.string.ui_uploader_status_back)
  map.put("ui_uploader_status_init", Res.string.ui_uploader_status_init)
  map.put("ui_uploader_status_processing", Res.string.ui_uploader_status_processing)
  map.put("ui_uploader_status_secure_legend", Res.string.ui_uploader_status_secure_legend)
  map.put("ui_uploader_status_secure_transfer", Res.string.ui_uploader_status_secure_transfer)
  map.put("ui_uploader_status_uploading", Res.string.ui_uploader_status_uploading)
  map.put("ui_uploader_subtitle", Res.string.ui_uploader_subtitle)
  map.put("ui_uploader_title", Res.string.ui_uploader_title)
  map.put("ui_users_activity_btn_next", Res.string.ui_users_activity_btn_next)
  map.put("ui_users_activity_btn_prev", Res.string.ui_users_activity_btn_prev)
  map.put("ui_users_activity_empty", Res.string.ui_users_activity_empty)
  map.put("ui_users_activity_filter_action", Res.string.ui_users_activity_filter_action)
  map.put("ui_users_activity_filter_all", Res.string.ui_users_activity_filter_all)
  map.put("ui_users_activity_filter_target", Res.string.ui_users_activity_filter_target)
  map.put("ui_users_activity_header_action", Res.string.ui_users_activity_header_action)
  map.put("ui_users_activity_header_details", Res.string.ui_users_activity_header_details)
  map.put("ui_users_activity_header_timestamp", Res.string.ui_users_activity_header_timestamp)
  map.put("ui_users_activity_header_user", Res.string.ui_users_activity_header_user)
  map.put("ui_users_activity_hours_ago", Res.string.ui_users_activity_hours_ago)
  map.put("ui_users_activity_mins_ago", Res.string.ui_users_activity_mins_ago)
  map.put("ui_users_activity_now", Res.string.ui_users_activity_now)
  map.put("ui_users_activity_title", Res.string.ui_users_activity_title)
  map.put("ui_users_detail_btn_audit_trail", Res.string.ui_users_detail_btn_audit_trail)
  map.put("ui_users_detail_btn_delete", Res.string.ui_users_detail_btn_delete)
  map.put("ui_users_detail_btn_edit", Res.string.ui_users_detail_btn_edit)
  map.put("ui_users_detail_btn_reset_pass", Res.string.ui_users_detail_btn_reset_pass)
  map.put("ui_users_detail_cat_campaigns", Res.string.ui_users_detail_cat_campaigns)
  map.put("ui_users_detail_cat_company", Res.string.ui_users_detail_cat_company)
  map.put("ui_users_detail_cat_devices", Res.string.ui_users_detail_cat_devices)
  map.put("ui_users_detail_cat_locations", Res.string.ui_users_detail_cat_locations)
  map.put("ui_users_detail_cat_media", Res.string.ui_users_detail_cat_media)
  map.put("ui_users_detail_cat_users", Res.string.ui_users_detail_cat_users)
  map.put("ui_users_detail_delete_btn_confirm", Res.string.ui_users_detail_delete_btn_confirm)
  map.put("ui_users_detail_delete_btn_dismiss", Res.string.ui_users_detail_delete_btn_dismiss)
  map.put("ui_users_detail_delete_confirm_message", Res.string.ui_users_detail_delete_confirm_message)
  map.put("ui_users_detail_delete_confirm_title", Res.string.ui_users_detail_delete_confirm_title)
  map.put("ui_users_detail_header_category", Res.string.ui_users_detail_header_category)
  map.put("ui_users_detail_header_delete", Res.string.ui_users_detail_header_delete)
  map.put("ui_users_detail_header_edit", Res.string.ui_users_detail_header_edit)
  map.put("ui_users_detail_header_view", Res.string.ui_users_detail_header_view)
  map.put("ui_users_detail_info_dialog_title", Res.string.ui_users_detail_info_dialog_title)
  map.put("ui_users_detail_log_api_key", Res.string.ui_users_detail_log_api_key)
  map.put("ui_users_detail_log_api_key_sub", Res.string.ui_users_detail_log_api_key_sub)
  map.put("ui_users_detail_log_media", Res.string.ui_users_detail_log_media)
  map.put("ui_users_detail_log_media_sub", Res.string.ui_users_detail_log_media_sub)
  map.put("ui_users_detail_log_sync", Res.string.ui_users_detail_log_sync)
  map.put("ui_users_detail_log_sync_sub", Res.string.ui_users_detail_log_sync_sub)
  map.put("ui_users_detail_reset_success_msg", Res.string.ui_users_detail_reset_success_msg)
  map.put("ui_users_detail_title_permissions_matrix", Res.string.ui_users_detail_title_permissions_matrix)
  map.put("ui_users_detail_title_recent_logs", Res.string.ui_users_detail_title_recent_logs)
  map.put("ui_users_edit_btn_ok", Res.string.ui_users_edit_btn_ok)
  map.put("ui_users_edit_btn_save", Res.string.ui_users_edit_btn_save)
  map.put("ui_users_edit_error_title", Res.string.ui_users_edit_error_title)
  map.put("ui_users_edit_label_full_name", Res.string.ui_users_edit_label_full_name)
  map.put("ui_users_edit_label_login_id", Res.string.ui_users_edit_label_login_id)
  map.put("ui_users_edit_role_admin", Res.string.ui_users_edit_role_admin)
  map.put("ui_users_edit_role_campaign_publisher", Res.string.ui_users_edit_role_campaign_publisher)
  map.put("ui_users_edit_role_campaign_viewer", Res.string.ui_users_edit_role_campaign_viewer)
  map.put("ui_users_edit_role_technic", Res.string.ui_users_edit_role_technic)
  map.put("ui_users_edit_role_warning_message", Res.string.ui_users_edit_role_warning_message)
  map.put("ui_users_edit_role_warning_title", Res.string.ui_users_edit_role_warning_title)
  map.put("ui_users_edit_section_roles", Res.string.ui_users_edit_section_roles)
  map.put("ui_users_edit_title_user_profile", Res.string.ui_users_edit_title_user_profile)
  map.put("ui_users_listing_btn_add_user", Res.string.ui_users_listing_btn_add_user)
  map.put("ui_users_listing_btn_load_more", Res.string.ui_users_listing_btn_load_more)
  map.put("ui_users_listing_header_activity", Res.string.ui_users_listing_header_activity)
  map.put("ui_users_listing_header_identity", Res.string.ui_users_listing_header_identity)
  map.put("ui_users_listing_no_users_found", Res.string.ui_users_listing_no_users_found)
  map.put("ui_users_listing_search_placeholder", Res.string.ui_users_listing_search_placeholder)
  map.put("ui_users_listing_showing", Res.string.ui_users_listing_showing)
  map.put("ui_users_splash_desc", Res.string.ui_users_splash_desc)
  map.put("ui_users_splash_title", Res.string.ui_users_splash_title)
  map.put("users", Res.string.users)
  map.put("yes", Res.string.yes)
}
